var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Injectable } from 'angular-ts-decorators';
let OrganizationService = class OrganizationService {
    $http;
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http'];
    constructor($http) {
        this.$http = $http;
    }
    getOrganizations(page, page_size, filter, encodeIds, onlyOrga, showDeleted) {
        let url = '/accounts/getOrganizations';
        url += '?page=' + page;
        url += '&page_size=' + page_size;
        url += '&filter=' + encodeURIComponent(filter);
        url += '&hash=' + new Date().getTime();
        url += '&encodeIds=' + !!encodeIds;
        url += '&onlyOrga=' + !!onlyOrga;
        url += '&withDeleted=' + !!showDeleted;
        return this.$http.get(url).then((res) => res.data);
    }
    getOrganizationById(organizationId) {
        const url = `/accounts/getOrganization/${organizationId}`;
        return this.$http.get(url).then((resp) => {
            return resp.data;
        });
    }
    updateOrganization(model) {
        return this.$http.post('/accounts/update/organization', model);
    }
    deleteOrganization(orga_id) {
        return this.$http.post('/accounts/delete/organization', {
            orga_id,
        });
    }
    restoreOrganization(orga_id) {
        return this.$http.post('/accounts/restore/organization', {
            orga_id,
        });
    }
    deleteSubscription(subscription_id, orga_id) {
        return this.$http.post('/accounts/delete/subscription', {
            subscription_id,
            orga_id,
        });
    }
    createOrganization(model) {
        return this.$http.post('/accounts/create/organization', model);
    }
    getOrganizationEmailConflict(email) {
        return this.$http
            .post('/accounts/organization-email-conflict', { email })
            .then((response) => response.data);
    }
};
OrganizationService = __decorate([
    Injectable('OrganizationService'),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object])
], OrganizationService);
export { OrganizationService };
